import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

interface ListingProps {
  search: string;
  pageNo: number;
}

const LoginService = (payload: LoginType) => {
  return HTTP_CLIENT.post(Endpoint.auth.login, payload);
};

const ForgotPasswordService = (payload: ForgotPasswordType) => {
  return HTTP_CLIENT.post(Endpoint.auth.forgotPassword, payload);
};

interface ResetPasswordServiceProps {
  password: string;
  token: string;
}

const ResetPasswordService = (payload: ResetPasswordServiceProps) => {
  return HTTP_CLIENT.post(
    Endpoint.auth.resetPassword,
    {
      password: payload.password,
    },
    {
      headers: {
        Authorization: `Bearer ${payload.token}`,
      },
    }
  );
};

const LogoutService = () => {
  return HTTP_CLIENT.post(Endpoint.auth.logout);
};

const GetForgotRequestsService = (payload: ListingProps) => {
  return HTTP_CLIENT.get(
    Endpoint.auth.passwordRequests +
      `?search=${payload.search}&pageNo=${payload.pageNo}`
  );
};

const GeneratePasswordService = (id: string) => {
  return HTTP_CLIENT.put(Endpoint.auth.generatePassword.replace(":id", id));
};

const DeletePasswordRequest = (id: string) => {
  return HTTP_CLIENT.delete(Endpoint.auth.deleteRequest.replace(":id", id));
};

export {
  LoginService,
  ForgotPasswordService,
  ResetPasswordService,
  LogoutService,
  GetForgotRequestsService,
  GeneratePasswordService,
  DeletePasswordRequest,
};
